"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var CollectionsSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M12.4824747,13.5731244 L15.1127015,8.18036015 L12,6.66219418 L12,11 C12,11.5522847 11.5522847,12 11,12 L10.0963684,12 C10.0739227,12.1218693 10.029023,12.2389368 9.96389725,12.3447322 L12.4824747,13.5731244 Z M5.95589649,14.4719185 C5.45950625,14.7140242 4.860837,14.5078858 4.6187313,14.0114956 L1.98850442,8.6187313 C1.74639872,8.12234106 1.95253708,7.52367181 2.44892732,7.28156611 L6,5.54959224 L6,5 C6,4.44771525 6.44771525,4 7,4 L11,4 C11.5522847,4 12,4.44771525 12,5 L12,5.54959224 L15.5510727,7.28156611 C16.0474629,7.52367181 16.2536013,8.12234106 16.0114956,8.6187313 L13.3812687,14.0114956 C13.139163,14.5078858 12.5404938,14.7140242 12.0441035,14.4719185 L9,12.98721 L5.95589649,14.4719185 Z M11,11 L11,5 L7,5 L7,5.57106783 C7.15929694,5.66719401 7.29363892,5.80883675 7.3812687,5.98850442 L9.82553841,11 L11,11 Z M2.88729847,8.18036015 L5.51752535,13.5731244 L9.11270153,11.8196398 L6.48247465,6.42687557 L2.88729847,8.18036015 Z" })));
};
CollectionsSmall.displayName = 'CollectionsSmall';
exports.default = CollectionsSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=CollectionsSmall.js.map